import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../helper/auth';
import config from '../config';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(auth.getUser());
    const [isAuthenticated, setIsAuthenticated] = useState(auth.isAuthenticated());

    // Re-hydrate user profile from server on app load
    // This ensures profile_image updated from the mobile app is reflected here
    useEffect(() => {
        if (auth.isAuthenticated()) {
            auth.fetch(`${config.API_BASE_URL}/api/auth/me`)
                .then(r => r.ok ? r.json() : null)
                .then(freshUser => {
                    if (freshUser) {
                        const merged = { ...auth.getUser(), ...freshUser };
                        auth.login(auth.getToken(), merged);
                        setUser(merged);
                    }
                })
                .catch(() => {}); // Silent fail — don't break the app
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const login = (token, userData) => {
        auth.login(token, userData);
        setUser(userData);
        setIsAuthenticated(true);
    };

    const logout = () => {
        auth.logout();
        setUser(null);
        setIsAuthenticated(false);
    };

    const updateUser = (userData) => {
        const updatedUser = { ...user, ...userData };
        auth.login(auth.getToken(), updatedUser);
        setUser(updatedUser);
    };

    const value = {
        auth: {
            ...auth,
            login,
            logout
        },
        user,
        updateUser,
        isAuthenticated
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
